import "core-js/modules/es.array.push.js";
import axios from "axios";
import moment from "moment";
import { pinyin } from "pinyin";

import { ElLoading } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/loading/style/css';
export default {
  data() {
    return {
      institution: sessionStorage.getItem("institution"),
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      // 选择日期范围
      currentMonth: moment().format("YYYY-MM"),
      selectedMonth: "",
      monthDates: [],
      dateRange: [],
      selectAllTime: false,
      consultantDateRange: {},
      // 学生
      studentList: [],
      studentNames: {},
      oriStudentList: [],
      studentSources: {},
      // 班级
      classList: [],
      classNames: {},
      classType: {},
      oriClassList: [],
      // 顾问
      consultantList: [],
      consultantNames: {},
      selectedConsultantIndex: 0,
      showLeftArrow: false,
      showRightArrow: true,
      // 列表切换
      selectedListIndex: 0,
      listName: ["交易记录", "退费记录", "已消金额", "未消金额"],
      showDetail: true,
      // 顾问业绩记录
      consultantPay: {},
      consultantRealPayTotal: {},
      consultantPayTotal: {},
      consultantRefund: {},
      consultantRefundTotal: {},
      consultantRefundServiceFeeTotal: {},
      consultantRefundRealTotal: {},
      consultantAttendFee: {},
      consultantAttendFeeTotal: {},
      consultantAttendFeeSummary: {},
      consultantUnattendFee: {},
      consultantUnattendFeeSummary: {},
      consultantBalance: {},
      // 全部时间的业绩
      allTimePerformance: {},
      // 顾问业绩排名
      consultantPerformance: {},
      consultantPerformanceRank: {},
      // 顾问页面
      showConsultantPage: false,
      // 增加顾问页面
      showAddConsultantPage: false,
      isEditConsultant: false,
      consultantName: "",
      consultantPhone: "",
      years: [],
      selectedYear: moment().format("YYYY"),
      months: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
      monthsPerformanceTarget: {},
      totalTarget: 0,
      //
      tipResolver: null,
      showTip: false,
      tipMessage: "",
      tipNeedInput: false,
      tipInputText: ""
    };
  },
  async mounted() {
    const mountT0 = performance.now();
    let stepT0 = mountT0;
    const logStep = label => {
      const t = performance.now();
      console.log(`[consultantPerformance mounted] ${label}: ${(t - stepT0).toFixed(1)}ms`);
      stepT0 = t;
    };

    // 基础数据：并行
    await Promise.all([(async () => {
      const t0 = performance.now();
      await this.getStudentList();
      console.log(`[consultantPerformance mounted] getStudentList 用时: ${(performance.now() - t0).toFixed(1)}ms`);
    })(), (async () => {
      const t0 = performance.now();
      await this.getClassList();
      console.log(`[consultantPerformance mounted] getClassList 用时: ${(performance.now() - t0).toFixed(1)}ms`);
    })(), (async () => {
      const t0 = performance.now();
      await this.getConsultantList();
      console.log(`[consultantPerformance mounted] getConsultantList 用时: ${(performance.now() - t0).toFixed(1)}ms`);
    })()]);
    logStep("并行：getStudentList / getClassList / getConsultantList");

    //
    let currentYear = parseInt(moment().format("YYYY"));
    for (let i = currentYear - 3; i <= currentYear + 5; i++) {
      this.years.push(i.toString());
    }
    logStep("初始化 years");

    // 初始当月
    this.selectedMonth = this.currentMonth;
    // 获取当月顾问业绩
    // 获取选择的月份第一天和最后一天
    const monthStartDate = moment(this.selectedMonth).startOf("month").format("YYYY-MM-DD");
    const monthEndDate = moment(this.selectedMonth).endOf("month").format("YYYY-MM-DD");
    this.dateRange = [monthStartDate, monthEndDate];
    this.selectAllTime = false;
    await this.getConsultantPerformance();
    logStep("getConsultantPerformance(当月)");

    // 获取顾问全部时间的日期范围
    await this.getConsultantDateRange();
    logStep("getConsultantDateRange");

    // 顾问数少于等于5个，顾问列表向右箭头不显示
    if (this.consultantList.length <= 5) {
      this.showRightArrow = false;
    }
    logStep("初始化 showRightArrow");
    console.log(`[consultantPerformance mounted] 总用时: ${(performance.now() - mountT0).toFixed(1)}ms`);
  },
  methods: {
    // 获取顾问列表
    async getConsultantList() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/enrollAndClear/enrollment/getSalesPerson", params);
        if (resp1.data.code == "0000") {
          this.consultantList = resp1.data.data;
          this.consultantNames = {};
          for (let i = 0; i < this.consultantList.length; i++) {
            this.consultantNames[this.consultantList[i].id] = this.consultantList[i].name;
          }

          // performanceTarget json化
          for (let i = 0; i < this.consultantList.length; i++) {
            if (this.consultantList[i].performanceTarget) {
              this.consultantList[i].performanceTarget = JSON.parse(this.consultantList[i].performanceTarget);
            } else {
              this.consultantList[i].performanceTarget = {};
            }
          }

          // 得到顾问名首字母
          for (let i = 0; i < this.consultantList.length; i++) {
            this.consultantList[i].nameFirstLetter = pinyin(this.consultantList[i].name, {
              style: pinyin.STYLE_FIRST_LETTER
            })[0][0];

            // 如果是英文, 取第一个字母
            if (this.consultantList[i].nameFirstLetter.length > 1) {
              this.consultantList[i].nameFirstLetter = this.consultantList[i].nameFirstLetter.substring(0, 1);
            }

            // 大写字母
            this.consultantList[i].nameFirstLetter = this.consultantList[i].nameFirstLetter.toUpperCase();
          }
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    // 获取顾问业绩
    async getConsultantPerformance() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        // 有些顾问，没有全部时间的日期范围
        if (!this.dateRange || !this.dateRange[0]) {
          this.dateRange = [];
          this.dateRange[0] = moment().format("YYYY-MM-DD");
          this.dateRange[1] = moment().format("YYYY-MM-DD");
        }
        let params = {
          institution: this.institution,
          dateRange: this.dateRange
        };
        let resp1 = await axios.post("https://backend.wonology.com/finance/consultantPerformance/getConsultantPerformance", params);
        if (resp1.data.code == "0000") {
          // console.log("顾问业绩resp1.data.data:", resp1.data.data);

          // 全部时间业绩
          if (this.selectAllTime) {
            this.allTimePerformance = resp1.data.data;

            ///////////////////
            // 交易记录
            this.allTimePerformance.consultantRealPayTotal = {};
            this.allTimePerformance.consultantPayTotal = {};
            for (let consultantId in this.allTimePerformance.consultantPay) {
              let total = 0;
              for (let i in this.allTimePerformance.consultantPay[consultantId]) {
                total += this.allTimePerformance.consultantPay[consultantId][i].amount;
              }
              this.allTimePerformance.consultantPayTotal[consultantId] = total;
              total = 0;
              for (let i in this.allTimePerformance.consultantPay[consultantId]) {
                // 如果有 real_prepay 字段，则用 real_prepay 计算总额
                if (this.allTimePerformance.consultantPay[consultantId][i].real_prepay) {
                  total += this.allTimePerformance.consultantPay[consultantId][i].real_prepay;
                }
                // 否则用 amount 计算总额
                else {
                  total += this.allTimePerformance.consultantPay[consultantId][i].amount;
                }
              }
              this.allTimePerformance.consultantRealPayTotal[consultantId] = total;
            }

            ///////////////////
            // 退费记录

            ///////////////////
            // 已消记录
            this.allTimePerformance.consultantAttendFeeTotal = {};
            for (let consultantId in this.allTimePerformance.consultantAttendFee) {
              let total = 0;
              for (let i in this.allTimePerformance.consultantAttendFee[consultantId]) {
                total += this.allTimePerformance.consultantAttendFee[consultantId][i].amount;
              }
              this.allTimePerformance.consultantAttendFeeTotal[consultantId] = total;
            }

            ///////////////////
            // 未消记录
            this.allTimePerformance.consultantUnattendFeeTotal = {};
            // 每个顾问
            for (let index in this.consultantList) {
              let consultantId = this.consultantList[index].id;
              let total = 0;
              for (let i in this.allTimePerformance.consultantUnattendFee[consultantId]) {
                total += this.allTimePerformance.consultantUnattendFee[consultantId][i].amount;
              }

              // 未消金额合计，还要加余额剩余
              if (this.allTimePerformance.consultantBalance[consultantId]) {
                for (let studentId in this.allTimePerformance.consultantBalance[consultantId]) {
                  total += this.allTimePerformance.consultantBalance[consultantId][studentId];
                }
              }
              this.allTimePerformance.consultantUnattendFeeTotal[consultantId] = total;
            }
          }
          // 非全部时间, 指定日期范围
          else {
            ///////////////////
            // 交易记录
            this.consultantPay = resp1.data.data.consultantPay;
            this.consultantRealPayTotal = {};
            this.consultantPayTotal = {};
            for (let consultantId in this.consultantPay) {
              let total = 0;
              for (let i in this.consultantPay[consultantId]) {
                total += this.consultantPay[consultantId][i].amount;
              }
              this.consultantPayTotal[consultantId] = total;
              total = 0;
              for (let i in this.consultantPay[consultantId]) {
                // 如果有 real_prepay 字段，则用 real_prepay 计算总额
                if (this.consultantPay[consultantId][i].real_prepay) {
                  total += this.consultantPay[consultantId][i].real_prepay;
                }
                // 否则用 amount 计算总额
                else {
                  total += this.consultantPay[consultantId][i].amount;
                }
              }
              this.consultantRealPayTotal[consultantId] = total;
            }

            ///////////////////
            // 退费记录
            this.consultantRefund = resp1.data.data.consultantRefund;
            this.consultantRefundTotal = {};
            this.consultantRefundServiceFeeTotal = {};
            this.consultantRefundRealTotal = {};
            for (let consultantId in this.consultantRefund) {
              if (!this.consultantRefundTotal[consultantId]) {
                this.consultantRefundTotal[consultantId] = 0;
              }
              if (!this.consultantRefundServiceFeeTotal[consultantId]) {
                this.consultantRefundServiceFeeTotal[consultantId] = 0;
              }
              if (!this.consultantRefundRealTotal[consultantId]) {
                this.consultantRefundRealTotal[consultantId] = 0;
              }
              for (let i in this.consultantRefund[consultantId]) {
                this.consultantRefundTotal[consultantId] += this.consultantRefund[consultantId][i].refundFee;
                this.consultantRefundServiceFeeTotal[consultantId] += this.consultantRefund[consultantId][i].refundServiceFee;
                this.consultantRefundRealTotal[consultantId] += this.consultantRefund[consultantId][i].refundRealFee;
              }
            }
            // console.log(
            //   "this.consultantRefundTotal:",
            //   this.consultantRefundTotal
            // );

            // 顾问业绩 = 实际缴费 - 退费
            for (let i in this.consultantList) {
              let consultantId = this.consultantList[i].id;
              if (!this.consultantRealPayTotal[consultantId]) {
                this.consultantRealPayTotal[consultantId] = 0;
              }
              if (!this.consultantRefundTotal[consultantId]) {
                this.consultantRefundTotal[consultantId] = 0;
              }
              this.consultantPerformance[consultantId] = this.consultantRealPayTotal[consultantId] - this.consultantRefundTotal[consultantId];
            }

            // 顾问业绩排名
            this.consultantPerformanceRank = {};
            for (let i in this.consultantList) {
              let consultantId = this.consultantList[i].id;

              // 如果顾问没业绩，赋值0
              if (!this.consultantPerformance[consultantId]) {
                this.consultantPerformance[consultantId] = 0;
              }
              this.consultantPerformanceRank[consultantId] = 1;
              for (let consultantId_2 in this.consultantPerformance) {
                // 每有一个顾问比自己业绩高，排名变大1
                if (this.consultantPerformance[consultantId] < this.consultantPerformance[consultantId_2]) {
                  this.consultantPerformanceRank[consultantId] += 1;
                }
              }
            }

            ///////////////////
            // 已消金额
            this.consultantAttendFee = resp1.data.data.consultantAttendFee;
            // console.log("resp1.data.data:", resp1.data.data);
            // console.log(
            //   "resp1.data.data.consultantAttendFee:",
            //   resp1.data.data.consultantAttendFee
            // );
            this.consultantAttendFeeTotal = {};
            for (let consultantId in this.consultantAttendFee) {
              let total = 0;
              for (let i in this.consultantAttendFee[consultantId]) {
                total += this.consultantAttendFee[consultantId][i].amount;
              }
              this.consultantAttendFeeTotal[consultantId] = total;
            }
            // console.log("this.consultantAttendFee:", this.consultantAttendFee);

            this.consultantBalance = resp1.data.data.consultantBalance;

            ///////////////////
            // 未消金额
            this.consultantUnattendFee = resp1.data.data.consultantUnattendFee;
            this.consultantUnattendFeeTotal = {};
            // 每个顾问
            for (let index in this.consultantList) {
              let consultantId = this.consultantList[index].id;
              let total = 0;
              for (let i in this.consultantUnattendFee[consultantId]) {
                total += this.consultantUnattendFee[consultantId][i].amount;
              }
              if (this.consultantBalance[consultantId]) {
                for (let studentId in this.consultantBalance[consultantId]) {
                  total += this.consultantBalance[consultantId][studentId];
                }
              }
              this.consultantUnattendFeeTotal[consultantId] = total;
            }
            this.consultantAttendFeeSummary = resp1.data.data.consultantAttendFeeSummary;
            this.consultantUnattendFeeSummary = resp1.data.data.consultantUnattendFeeSummary;
          }

          // console.log("this.consultantAttendFee:", this.consultantAttendFee);
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    // 获取顾问全部时间的日期范围
    async getConsultantDateRange() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/finance/consultantPerformance/getConsultantDateRange", params);
        if (resp1.data.code == "0000") {
          this.consultantDateRange = resp1.data.data;

          // console.log("this.consultantDateRange:", this.consultantDateRange);
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    // 获取学生列表
    async getStudentList() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/enrollAndClear/studentManagement/getStudentList", params);
        if (resp1.data.code == "0000") {
          this.studentList = resp1.data.data;

          // console.log("获取学生列表:", this.studentList);

          this.oriStudentList = JSON.parse(JSON.stringify(this.studentList));
          this.studentNames = {};
          this.studentSources = {};
          for (let i in this.studentList) {
            this.studentNames[this.studentList[i].id] = this.studentList[i].name;
            this.studentSources[this.studentList[i].id] = this.studentList[i].customer_source;
          }
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    // 获取班级列表
    async getClassList() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/courseArrange/getClassList", params);
        if (resp1.data.code == "0000") {
          this.classList = resp1.data.data;

          // 部分字段json.parse()
          for (let i in this.classList) {
            this.classList[i].teacherIds = JSON.parse(this.classList[i].teacherIds);
            // 将 teacherId 倒序排列
            this.classList[i].teacherIds.sort((a, b) => b - a);
            this.classList[i].courses = JSON.parse(this.classList[i].courses);
            this.classList[i].periods = JSON.parse(this.classList[i].periods);
          }
          this.oriClassList = JSON.parse(JSON.stringify(this.classList));

          // console.log("获取班级列表 this.classList:", this.classList);

          // classId转换为className
          for (let i = 0; i < this.classList.length; i++) {
            this.classNames[this.classList[i].id] = this.classList[i].name;
            this.classType[this.classList[i].id] = this.classList[i].courseType;
          }
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    // 选择顾问
    async selectConsultant(index) {
      this.selectedConsultantIndex = index;

      // 看未消金额时，才需要全部时间的数据
      if (this.selectedListIndex == 3) {
        // 获取顾问全部时间的日期范围
        if (this.consultantList[this.selectedConsultantIndex]) {
          this.dateRange = this.consultantDateRange[this.consultantList[this.selectedConsultantIndex].id];
        }
        this.selectAllTime = true;

        // 重新获取顾问全部时间的业绩
        await this.getConsultantPerformance();
      }
    },
    // 每次点击, 右移一个顾问的宽度103
    clickLeftArrow() {
      let el = document.getElementById("consultantListDiv");

      // 如果不存在，不需要处理
      if (!el.style.marginLeft) {}
      // 如果存在，右移103
      else {
        // 负数
        let marginLeft = parseInt(el.style.marginLeft.split("px")[0]);
        marginLeft += 103;
        el.style.marginLeft = marginLeft + "px";
        this.showRightArrow = true;
      }
      let marginLeft = parseInt(el.style.marginLeft.split("px")[0]);
      // 已经显示了最左的顾问，就不显示右边箭头了
      if (marginLeft >= 0) {
        this.showLeftArrow = false;
      }
      // 还没有显示到最左的顾问，继续显示右边箭头
      else {
        this.showLeftArrow = true;
      }
    },
    // 每次点击, 左移一个顾问的宽度103
    clickRightArrow() {
      let el = document.getElementById("consultantListDiv");

      // console.log("el.style.marginLeft:", el.style.marginLeft);

      // 初始不存在
      if (!el.style.marginLeft) {
        // 如果大于5个顾问，左移103, 显示左边箭头
        if (this.consultantList.length - 5 > 0) {
          // 左移
          el.style.marginLeft = "-" + 103 + "px";
          this.showLeftArrow = true;
        }
        // 如果少于等于5个顾问，不左移，不显示左边箭头，也不显示右边箭头
        else {
          // console.log("小于5个顾问，不左移");

          this.showLeftArrow = false;
          this.showRightArrow = false;
        }
      }
      // 存在，左移103
      else {
        // 这里获取到的值是负数，没事
        let marginLeft = parseInt(el.style.marginLeft.split("px")[0]);

        // 已经显示了最右边的顾问，就不左移了
        if (0 - marginLeft >= 103 * (this.consultantList.length - 5)) {}
        // 还没有显示到最右边的顾问，左移
        else {
          // 左移
          marginLeft -= 103;
          el.style.marginLeft = marginLeft + "px";
        }

        // 显示左边箭头
        this.showLeftArrow = true;
      }
      let marginLeft = parseInt(el.style.marginLeft.split("px")[0]);
      // 已经显示了最右边的顾问，就不显示右边箭头了
      if (0 - marginLeft >= 103 * (this.consultantList.length - 5)) {
        this.showRightArrow = false;
      }
      // 还没有显示到最右边的顾问，继续显示右边箭头
      else {
        this.showRightArrow = true;
      }
    },
    // 选择月份
    async handleMonthChange() {
      // 获取选择的月份第一天和最后一天
      const monthStartDate = moment(this.selectedMonth).startOf("month").format("YYYY-MM-DD");
      const monthEndDate = moment(this.selectedMonth).endOf("month").format("YYYY-MM-DD");
      this.dateRange = [monthStartDate, monthEndDate];
      this.selectAllTime = false;
      await this.dateRangeChange();
    },
    // 修改日期范围，重新获取顾问业绩
    async dateRangeChange() {
      console.log("this.dateRange:", this.dateRange);
      await this.getConsultantPerformance();
    },
    async selectAllTimeChange() {
      // 选择 全部时间
      if (this.selectAllTime) {
        // 获取顾问全部时间的日期范围
        if (this.consultantList[this.selectedConsultantIndex]) {
          this.dateRange = this.consultantDateRange[this.consultantList[this.selectedConsultantIndex].id];
        }
        await this.getConsultantPerformance();
      }
      // 取消选择 全部时间
      else {}
    },
    // 点击 全部时间 文字 也是选择
    async clickSelectAllTimeWord() {
      this.selectAllTime = !this.selectAllTime;
      await this.selectAllTimeChange();
    },
    // 选择 交易记录/已消金额/未消金额
    async clickList(index) {
      this.selectedListIndex = index;

      // 未消金额 看全部时间的数据
      if (this.selectedListIndex == 3) {
        this.selectAllTime = true;
        await this.selectAllTimeChange();
      }
      //
      else {
        this.selectAllTime = false;
        await this.selectAllTimeChange();
      }
    },
    // 选择显示明细
    selectShowDetailChange() {},
    // 点击 显示明细 文字 也是选择
    clickShowDetailWord() {
      this.showDetail = !this.showDetail;
      this.selectShowDetailChange();
    },
    // 查看顾问页面
    viewConsultantInfo() {
      this.showConsultantPage = true;
    },
    closeConsultantPage() {
      this.showConsultantPage = false;
    },
    // 添加顾问, 出现弹窗
    addConsultant() {
      this.consultantName = "";
      this.consultantPhone = "";
      this.monthsPerformanceTarget = {};
      this.totalTarget = 0;
      this.showAddConsultantPage = true;
      this.isEditConsultant = false;
    },
    // 确认添加/编辑顾问
    async confirmAddConsultant() {
      if (!this.consultantName) {
        alert("请输入顾问姓名");
        return;
      }
      if (!this.consultantPhone) {
        alert("请输入联系电话");
        return;
      }
      if (!this.validatePhone()) {
        // alert("请输入正确的手机号");

        return;
      }
      console.log("this.monthsPerformanceTarget:", this.monthsPerformanceTarget);

      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          consultantName: this.consultantName,
          consultantPhone: this.consultantPhone,
          performanceTarget: this.monthsPerformanceTarget,
          institution: this.institution
        };
        // 如果是编辑顾问
        if (this.isEditConsultant) {
          params = {
            consultantName: this.consultantName,
            consultantPhone: this.consultantPhone,
            performanceTarget: this.monthsPerformanceTarget,
            institution: this.institution,
            consultantId: this.consultantList[this.selectedConsultantIndex].id,
            isEdit: true
          };
        }
        let resp1 = await axios.post("https://backend.wonology.com/finance/consultantPerformance/addConsultant", params);
        if (resp1.data.code == "0000") {
          this.showAddConsultantPage = false;

          // 重新获取顾问列表
          await this.getConsultantList();
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    // 取消添加/编辑顾问
    cancelAddConsultant() {
      this.showAddConsultantPage = false;
    },
    // 编辑顾问
    editConsultant(consultantIndex) {
      this.selectedConsultantIndex = consultantIndex;

      // 填充数据
      this.consultantName = this.consultantList[consultantIndex].name;
      this.consultantPhone = this.consultantList[consultantIndex].phone;
      this.monthsPerformanceTarget = this.consultantList[consultantIndex].performanceTarget;
      this.totalTarget = 0;
      for (let i = 1; i <= 12; i++) {
        let month = this.selectedYear + "-" + i.toString().padStart(2, "0");
        if (this.monthsPerformanceTarget[month]) {
          this.totalTarget += parseInt(this.monthsPerformanceTarget[month]);
        }
      }
      this.showAddConsultantPage = true;
      this.isEditConsultant = true;
    },
    // 切换年份，重新计算总业绩指标
    selectedYearChange() {
      this.totalTarget = 0;
      for (let i = 1; i <= 12; i++) {
        let month = this.selectedYear + "-" + i.toString().padStart(2, "0");
        if (this.monthsPerformanceTarget[month]) {
          this.totalTarget += parseInt(this.monthsPerformanceTarget[month]);
        }
      }
    },
    // 月份的指标变化，重新计算总业绩指标
    monthsTargetChange() {
      this.totalTarget = 0;
      for (let i = 1; i <= 12; i++) {
        let month = this.selectedYear + "-" + i.toString().padStart(2, "0");
        if (this.monthsPerformanceTarget[month]) {
          this.totalTarget += parseInt(this.monthsPerformanceTarget[month]);
        }
      }
    },
    // 删除顾问
    async deleteConsultant(consultantIndex) {
      // 确认删除弹窗
      this.showTip = true;
      this.tipMessage = `确认删除'${this.consultantList[consultantIndex].name}'吗?`;

      // 注册resolve函数 （和回调还是有点区别，不过这个方法更好）
      // 后面通过 this.tipResolver(value) 返回值
      const tipConfirmed = await new Promise(resolve => {
        this.tipResolver = resolve;
      });
      if (tipConfirmed === "confirm") {
        // 用户选择确认，继续执行

        this.showTip = false;
        // 重置变量
        this.tipMessage = "";
        this.tipNeedInput = false;
      } else {
        // 用户选择取消，返回

        return;
      }

      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          consultantId: this.consultantList[consultantIndex].id
        };
        let resp1 = await axios.post("https://backend.wonology.com/finance/consultantPerformance/deactivateConsultant", params);
        if (resp1.data.code == "0000") {
          // 重新获取顾问列表
          await this.getConsultantList();
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    // 校验手机号
    validatePhone(phone) {
      if (!phone) {
        phone = this.consultantPhone;
      }

      // 手机号正则表达式 (11位数字，以1开头, 第二个必须是3-9，剩下9个数字)
      const mobileRegex = /^1[3-9]\d{9}$/;
      if (!mobileRegex.test(phone)) {
        this.phoneValidate = false;
        alert("请输入正确的手机号");
        return false;
      }
      this.phoneValidate = true;
      return true;
    },
    // 提示弹窗 取消
    closeTip() {
      this.showTip = false;
      // 重置变量
      this.tipMessage = "";
      this.tipNeedInput = false;
      if (this.tipResolver) {
        // 传输结果
        this.tipResolver("cancel");
        this.tipResolver = null;
      }
    },
    confirmTip() {
      // this.showTip = false;
      // // 重置变量
      // this.tipMessage = "";
      // this.tipNeedInput = false;

      if (this.tipResolver) {
        // 传输结果
        this.tipResolver("confirm");
        this.tipResolver = null;
      }
    }
  }
};